import { useEffect } from "react";

const handleSearchParamUpdate = (show: boolean, id: string | undefined) => {
  if (!id) return;

  const searchParams = new URLSearchParams(window.location.search);
  const cleanSearchParams = () => searchParams.delete(id);

  if (show) {
    searchParams.set(id, "true");
  } else {
    cleanSearchParams();
  }

  const queryParams = searchParams.toString();
  const newUrl =
    window.location.pathname + (!!queryParams ? `?${queryParams}` : "");
  // Skip writes that would not change the URL. Safari throws a SecurityError
  // after 100 replaceState calls in 10 seconds, and this runs from every
  // Modal's effect, so repeated no-op writes crashed the page
  // (Error Tracking 572c86b6).
  if (newUrl === window.location.pathname + window.location.search) {
    return cleanSearchParams;
  }

  window.history.replaceState(null, "", newUrl);

  return cleanSearchParams;
};

export const useModalSearchParams = (
  id: string | undefined,
  isShowing: boolean
) => {
  useEffect(() => {
    if (!id) return;
    return handleSearchParamUpdate(isShowing, id);
  }, [isShowing]);

  return handleSearchParamUpdate;
};
